// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaimedToast-cls1_O9w","cls2":"PaperClaimedToast-cls2__px PaperClaimedToast-cls1_O9w"};